import { observable, set } from 'mobx';
import { RETAIL_FEE_REGION } from '../../../constants/RetailDeliveryFeeMappedTranslations';

class Order {
  @observable codSurchargeAmount: number;

  @observable currencyCode: string;

  @observable totalCost: number;

  @observable totalAppliedTax: number;

  @observable formattedTaxRate: string;

  @observable subTotal: number;

  @observable totalShippingPrice: number;

  @observable taxRate: number;

  @observable discount: number;

  @observable isGiftWrap: number;

  @observable giftWrapTotal: number;

  @observable itemsCount: number;

  @observable giftCardTotal: number;

  @observable subTotalWithoutDonations: number;

  @observable totalDonations: number;

  @observable totalIncludedTax: number;

  @observable taxIsEstimated: boolean;

  @observable rewardPointsPriceInCartFormatted: string;

  @observable totalRetailDeliveryFee: number;

  @observable retailDeliveryFeeMessage: RETAIL_FEE_REGION;

  static fromJSON(data: Order): Order {
    const order = new Order();
    set(order, data);

    return order;
  }
}

export default Order;
